import { FC } from 'react';

import { Avatar, AvatarProps } from '@bonusly/design-system';

import User from '../../types/user';

interface UserAvatarProps extends AvatarProps {
	onClick?: VoidFunction;
	user: Pick<User, 'display_name' | 'profile_pic_url'>;
}

export const UserAvatar: FC<UserAvatarProps> = ({ user: { display_name, profile_pic_url }, ...rest }) => (
	<Avatar name={display_name} src={profile_pic_url} {...rest} />
);
